import { getStore } from '../../../init-store';
import { selectUserUid } from '../features/user/selectors';

export function getUserUid() {
    const store = getStore();
    const state = store.getState();
    const userUid = selectUserUid(state);

    return userUid;
}
